// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.disclaimer[data-v-f3120658] {\n  padding: 0 35px;\n  left: 0;\n  right: 0;\n  position: absolute;\n}\n.abort-btn[data-v-f3120658] {\n  background-color: rgb(var(--status-aborted));\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
